export const xsBreakpoint = '@media (max-width: 600px)';
